<fui-pill-fascia (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()"
                 [hovered]="hovered">
    <fui-fixtures>
        @if (icon) {
            <fui-fixture>
                <ng-content select="fui-icon"></ng-content>
            </fui-fixture>
        }
        <fui-fixture>
            <fui-pill-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                            [title]="label"></fui-pill-label>
        </fui-fixture>
        <fui-spanning-fixture>
            <fui-input-dom>
                <input (blur)="onBlur($event)" [disabled]="disabled" #input (focus)="onFocus($event)"
                       [(ngModel)]="displayedValue"
                       [placeholder]="placeholder | translate" [tabindex]="tabindex" type="text" inputmode="decimal">
            </fui-input-dom>
        </fui-spanning-fixture>
        @if (removable) {
            <fui-fixture>
                <fui-mark-button (click)="remove()">
                    <fui-icon [height]="6" [icon]="'close'" [width]="6"></fui-icon>
                </fui-mark-button>
            </fui-fixture>
        }
    </fui-fixtures>
</fui-pill-fascia>
